import React from "react";
import "./Home.css";

export default function Home() {
  return (
    <div className="home">
      {/* ── Hero ── */}
      <section className="hero">
        <div className="stars-layer" aria-hidden="true">
          {Array.from({ length: 60 }).map((_, i) => (
            <span
              key={i}
              className="star"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                width: `${Math.random() * 3 + 1}px`,
                height: `${Math.random() * 3 + 1}px`,
              }}
            />
          ))}
        </div>
        <div className="hero-content">
          <p className="hero-eyebrow">🪐 वैदिक ज्योतिष • नेपाल</p>
          <h1 className="hero-title">
            तारा र ग्रहको
            <br />
            <span className="gradient-text">रहस्य जान्नुहोस्</span>
          </h1>
          <p className="hero-subtitle">
            नेपाली पञ्चाङ्ग, कुण्डली मिलान र ज्योतिष विद्याको विश्वसनीय स्रोत।
          </p>
        </div>
        <div className="hero-mandala" aria-hidden="true">
          <div className="mandala-ring ring-1" />
          <div className="mandala-ring ring-2" />
          <div className="mandala-ring ring-3" />
          <span className="mandala-om">ॐ</span>
        </div>
      </section>

      {/* ── Feature Cards ── */}
      <section className="features">
        <h2 className="section-title">हाम्रा सेवाहरू</h2>
        <div className="cards">
          <div className="card">
            <div className="card-icon">📅</div>
            <h3>पञ्चाङ्ग</h3>
            <p>
              आजको तिथि, वार, नक्षत्र, योग र करण सहितको सम्पूर्ण नेपाली
              पञ्चाङ्ग।
            </p>
          </div>
          <div className="card card-featured">
            <div className="card-icon">💫</div>
            <h3>कुण्डली मिलान</h3>
            <p>
              विवाहको लागि वर र वधूको जन्मकुण्डली मिलान गरी गुण, दोष र
              सुहाउँदोपन जाँच गर्नुहोस्।
            </p>
          </div>
          <div className="card">
            <div className="card-icon">🌙</div>
            <h3>राशिफल</h3>
            <p>तपाईंको राशि अनुसार दैनिक, साप्ताहिक र मासिक भविष्यफल।</p>
          </div>
        </div>
      </section>
    </div>
  );
}
